import BaseAPIService from '../base/base-api-service';
import PaySimpleCheckoutTokenModel from '../../model/paySimpleCheckoutToken.model';
import PaySimplePayment from '../../model/paySimplePayment.model';
import paymentsModel from '../../model/payments.model';
import EcheckPaymentModel from 'src/model/echeckPayment.model';

export interface IPaymentFilters {
  status: 'AT' | 'DT' | null;
  disposition: 'AW' | 'AD' | 'VT' | null;
  paymentDate?: string;
  userId?: string;
}

export interface IPagination {
  page: number;
  size?: number;
}

export interface IInvoiceEcheckPayment {
  invoiceNumber: number;
  orderNumber: number;
  paymentAmount: number;
  reasonNotes: string;
  transactionId: number;
}

export interface IEcheckPayment {
  email: string;
  invoices: IInvoiceEcheckPayment[];
  payment: {
    accountId: number;
    amount: number;
    paymentToken: string;
  };
  signature: string;
}
interface IBlankObj{
  data:[];
  pageNumber:number;
}

class PaySimpleService extends BaseAPIService<PaySimpleCheckoutTokenModel> {
  public paySimpleECheckEndpoint: string = 'accountapp/v1/echeck';

  constructor() {
    super(PaySimpleCheckoutTokenModel);
  }

  private buildPaymentParams = (
    filters: IPaymentFilters,
    pagination: IPagination
  ) => {
    const { status, disposition, paymentDate, userId } = filters;
    const { page } = pagination;

    const parameters: any = {
      status,
      disposition,
      paymentDate,
      userId,
      page
    };

    // Object.keys(parameters).forEach(key =>
    //   !parameters[key] ? delete parameters[key] : ''
    // );

    return parameters;
  };

  public getCheckoutToken(): Promise<PaySimpleCheckoutTokenModel> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.paySimpleECheckEndpoint}/checkouttoken`,
      method: 'get'
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error(error);
        throw error;
      });
  }

  public createECheckPayment(
    params: IEcheckPayment
  ): Promise<PaySimplePayment> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.paySimpleECheckEndpoint}/payments`,
      method: 'post',
      data: params
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  public getPayments(
    filters: IPaymentFilters,
    pagination: IPagination,
    sort?: any
  ): Promise<paymentsModel> {
    const params = this.buildPaymentParams(filters, pagination);
    const sortBy = sort ? sort : 'paymentDate,desc';
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.paySimpleECheckEndpoint}/payments?sort=${sortBy}`,
      method: 'get',
      params
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        console.error(error);
        const sendBlankObj: IBlankObj = {
          data: [],
          pageNumber: 0,
        };
        return sendBlankObj;
        // throw error;
      });
  }

  public updatePayment(
    databaseId: number,
    params: any
  ): Promise<EcheckPaymentModel> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.paySimpleECheckEndpoint}/payments/${databaseId}`,
      method: 'patch',
      data: params
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  public exportSelectedecheckSummary(
    type: string,
    paymentId: string,
    debitDataList: any,
    creditDataList: any,
    page: string
  ) {
    return new Promise((resolve, reject) => {
      let exportInvoicesEndpoint = '';
      exportInvoicesEndpoint = `${this.baseURL}accountapp/v1/invoice/selected/echeck/export?type=${type}&payment_id=${paymentId}&summary=admin`;
      this.doRequest({
        method: 'post',
        url: exportInvoicesEndpoint,
        data: {
          creditInvoice: [],
          debitInvoice: []
        },
        responseType: 'blob'
      })
        .then((response: any) => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No invoices to download');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
}

const paySimpleServiceInstance = new PaySimpleService();
Object.freeze(paySimpleServiceInstance);

export default paySimpleServiceInstance;
